// extracted by mini-css-extract-plugin
export default {"wrapper":"EventInfo_wrapper__OCBa0","green":"EventInfo_green__t7YHB","pink":"EventInfo_pink__goKhx"};